import React from 'react'

import Box from 'components_new/atoms/Box'
import Checkbox from 'components_new/atoms/Checkbox'
import ListItemText from 'components_new/atoms/List/ListItemText'
import MenuItem from 'components_new/atoms/Menu/MenuItem'
import TextField from 'components_new/atoms/TextField'

import SettingsGroup from 'components_new/molecules/SettingsGroup'
import SettingsItem from 'components_new/molecules/SettingsItem'

import { EAccountRole } from 'types/GlobalAccount'

import { useRoles } from 'redux/hooks/Accounts'
import { useTranslation } from 'language/translator'

interface SelectUserRoleProps {
  allowEconomy: boolean
  allowAnalyses: boolean
  disabled?: boolean
  role: EAccountRole
  setAllowEconomy: (_allow: boolean) => void
  setAllowAnalyses: (_allow: boolean) => void
  setRole: (_role: EAccountRole) => void
  showAnalyses: boolean
}

const SelectUserRole = (props: SelectUserRoleProps) => {
  const {
    allowEconomy,
    allowAnalyses,
    disabled,
    role,
    setAllowEconomy,
    setAllowAnalyses,
    setRole,
    showAnalyses
  } = props

  const { t, translateEnum } = useTranslation()
  const { roles, loading: loadingRoles } = useRoles()

  if (loadingRoles) {
    return null
  }

  return (
    <Box>
      <TextField
        label={t('users', 'role')}
        select={true}
        value={role}
        disabled={disabled}
      >
        {Object.values(roles).map((option, i) => {
          const translatedRole = translateEnum('account_roles', option.name)

          return (
            <MenuItem
              value={option.name}
              key={i}
              onClick={() => {
                setRole(option.name)

                if (option.name !== EAccountRole.VIEW && allowEconomy) {
                  setAllowEconomy(false)
                }

                if (option.name !== EAccountRole.VIEW && allowAnalyses) {
                  setAllowAnalyses(false)
                }
              }}
            >
              <ListItemText
                primary={translatedRole.title}
                secondary={translatedRole.summary}
                secondaryTypographyProps={{
                  color: 'text.secondary'
                }}
              />
            </MenuItem>
          )
        })}
      </TextField>
      {role === EAccountRole.VIEW && !disabled ? (
        <SettingsGroup>
          <SettingsItem
            body={t('users', 'economy_description')}
            icon={
              <Checkbox
                checked={allowEconomy}
                onChange={() => setAllowEconomy(!allowEconomy)}
                size="small"
              />
            }
            title={t('global', 'economy')}
          />
          {showAnalyses ? (
            <SettingsItem
              body={t('users', 'analyses_description')}
              icon={
                <Checkbox
                  checked={allowAnalyses}
                  onChange={() => setAllowAnalyses(!allowAnalyses)}
                  size="small"
                />
              }
              title={t('analyses', 'analyses')}
            />
          ) : null}
        </SettingsGroup>
      ) : null}
    </Box>
  )
}

export default SelectUserRole
